import { useTranslation } from 'react-i18next';
import { useInstallationContext } from '../../../../../context/installation';
import { ChannelTypeInternal, UserAction } from '../../../../../data-access/gql-types/graphql';
import { ChannelType } from '../../../types';

export const useCentralAction = () => {
  const { t } = useTranslation('common');
  const { selectedInstallationId } = useInstallationContext();
  const hasCentralAction = [ChannelTypeInternal.Switch, ChannelTypeInternal.Blind, ChannelTypeInternal.Light];

  const prepareCentralAction = (type: ChannelTypeInternal, channels: ChannelType[]) => {
    return {
      id: type,
      iconName: '',
      action: {
        installationId: selectedInstallationId,
        actionType: 'CENTRAL',
        channelType: type,
        name: t(`typesPlural.${type}`),
        id: type,
        sourceGroupId: '',
        channelActions: channels.map((channel) => ({
          channelId: channel.id,
          channelType: channel.data.type,
          activityType: 'CLIENT_CONTROLLED',
          value: '',
        })),
      },
    } as UserAction;
  };

  const createCentralAction = (type: ChannelTypeInternal, channels: ChannelType[]) => {
    if (hasCentralAction.includes(type) && channels.length > 1) {
      return prepareCentralAction(type, channels);
    }
  };

  return {
    createCentralAction,
    hasCentralAction,
  };
};
